import {
  ApiListRequest,
  ApiListResponse,
  FacilityDTO,
  FacilityStatus,
} from "@gymflow/types";
import { infiniteQueryOptions, QueryKey } from "@tanstack/react-query";

import { api } from "../../api";
import { numberPagination } from "../../numberPagination";

const keys = {
  all: () => ["hostedApiFacility"] as QueryKey,
  list: (filter: unknown) => [...keys.all(), "list", filter] as QueryKey,
};

export const hostedApiFacility = {
  keys,
  queries: {},
  infiniteQueries: {
    list: (
      params: {
        status?: FacilityStatus;
        id?: number[];
      } & ApiListRequest,
    ) =>
      infiniteQueryOptions({
        queryKey: keys.list(params),
        queryFn: async ({ pageParam }) => {
          return (
            await api.get<ApiListResponse<FacilityDTO>>(`/hosted/facility`, {
              params: { ...params, page: pageParam },
            })
          ).data;
        },
        ...numberPagination,
      }),
  },
  mutations: {},
};
